import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';

// STYLES
import * as S from '../../../Establishment/ListEstablishment/styles';
import * as D from 'js/components/DesignSystem/styles';
import * as E from 'js/components/DesignSystem/Table/styles';
import { AreaHeader, GoBack } from 'js/components/Configurations/CreateClub/styles';
import { Box, Button, Tooltip } from '@mui/material';
import {
  BoxSearch,
  ButtonDetails,
  ContainerSearch,
  Input,
  InputBox,
  SearchIconButton,
} from './styles';

// ICONES
import { MdArrowBackIosNew } from 'react-icons/md';
import AddIcon from '@mui/icons-material/Add';
import SendIcon from '@mui/icons-material/Send';
import searchIcon from 'styles/assets/SearchUser/search.svg';

// COMPONENTES
import CustomButtonsTable from 'js/components/TriiboComponents/Tables/CustomButtonsTable';

// API
import { getMotherNotificationById } from 'js/library/utils/API/Posts/Notifications/getMotherNotificationById';

export default function DataTableNotification({ paramsId, postId, sender }) {
  const history = useHistory();

  const [data, setData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredNotification, setFilteredNotification] = useState([]);

  const column = [
    { heading: 'Data', value: 'scheduleDate' },
    { heading: 'Título', value: 'notificationTitle' },
    { heading: 'Mensagem', value: 'resumedNotificationBody' },
    { heading: 'Origem', value: 'origin' },
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (postId) {
          const response = await getMotherNotificationById(postId);

          const filteredData = Object.values(response).map((item) => ({
            listUsersPath: item.listUsersPath,
            hasListUsers: item.hasListUsers,
            hasSenderUsers: item.hasSenderUsers,
            notificationGroupId: item.notificationGroupId,
            origin: item.origin,
            notificationTitle: item.notificationTitle,
            notificationBody: item.notificationBody,
            resumedNotificationBody:
              item.notificationBody.length > 50
                ? `${item.notificationBody.substring(0, 50)}...`
                : item.notificationBody,
            scheduleDate: new Date(item.scheduleDate).toLocaleString('pt-BR', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
              second: undefined,
            }),
          }));

          setData(filteredData);
        }
      } catch (error) {
        console.error('Ocorreu um erro na requisição:', error);
      }
    };
    fetchData();
  }, [postId]);

  const handleSearch = (e) => {
    const term = e.target.value.trim();
    setSearchTerm(term);

    const filtered = data.filter((notification) =>
      notification.notificationTitle.toLowerCase().includes(term)
    );
    setFilteredNotification(filtered);
  };

  const handleDetails = (selected) => {
    history.push({
      pathname: `/admin/configuracoes/listaPostagem/notificacoes/${paramsId}/${selected.notificationGroupId}`,
      state: selected,
    });
  };

  const componentReceiver = (column, childrens) => {
    return {
      columnComponent: (
        <>
          <E.TableTH>Detalhes</E.TableTH>
        </>
      ),
      childrenComponent:
        childrens === null ? null : (
          <>
            <E.TableTD>
              <Tooltip title="Ver detalhes" placement="top" style={{ marginRight: '1.2rem' }}>
                <ButtonDetails
                  variant="contained"
                  sx={{ marginLeft: '15px' }}
                  onClick={() => handleDetails(childrens)}
                >
                  <AddIcon size={10} />
                </ButtonDetails>
              </Tooltip>
            </E.TableTD>
          </>
        ),
    };
  };

  const handleRedirect = () => {
    history.push({
      pathname: `/admin/configuracoes/listaPostagem/notificacoes/${paramsId}/enviar`,
      state: {
        postId,
        sender,
      },
    });
  };

  return (
    <S.Container style={{ paddingBottom: '200px' }}>
      <AreaHeader
        style={{
          color: '#08bad0',
          justifyContent: 'end',
          padding: '1rem',
          marginLeft: '3rem',
        }}
      >
        <GoBack
          onClick={() => {
            window.history.back();
          }}
        >
          <MdArrowBackIosNew /> Voltar
        </GoBack>
      </AreaHeader>
      <D.TriiboH1
        style={{
          textAlign: 'center',
        }}
      >
        Lista de Notificações
      </D.TriiboH1>

      <ContainerSearch>
        <Box style={{ width: '75%' }}>
          <BoxSearch>
            <InputBox
              style={{
                boxShadow: '0px 3px 6px #00000029',
                borderRadius: '10px',
                minWidth: '290px',
              }}
            >
              <Input placeholder="Pesquise pelo título..." onChange={handleSearch} />
              <SearchIconButton onClick={(e) => e.preventDefault()}>
                <img src={searchIcon} alt="" />
              </SearchIconButton>
            </InputBox>
          </BoxSearch>
        </Box>

        <Button
          sx={{ textTransform: 'capitalize', fontWeight: '550' }}
          startIcon={<SendIcon size={10} />}
          variant="contained"
          onClick={handleRedirect}
        >
          Enviar Notificação
        </Button>
      </ContainerSearch>

      {(filteredNotification.length === 0 && searchTerm) || (!searchTerm && data.length === 0) ? (
        <p>Nenhuma notificação encontrada.</p>
      ) : (
        <CustomButtonsTable
          data={searchTerm ? filteredNotification : data}
          column={column}
          perPage={10}
          componentReceiver={componentReceiver}
        />
      )}
    </S.Container>
  );
}
